import { render, staticRenderFns } from "./Detalle_x_Institucion.vue?vue&type=template&id=184eeeff&scoped=true"
import script from "./Detalle_x_Institucion.vue?vue&type=script&lang=js"
export * from "./Detalle_x_Institucion.vue?vue&type=script&lang=js"
import style0 from "./Detalle_x_Institucion.vue?vue&type=style&index=0&id=184eeeff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184eeeff",
  null
  
)

export default component.exports